import React, { useEffect, useState } from 'react';
import HelpIcon from 'src/components/ui-icons/menu/HelpIcon';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { DownloadIcon, FileIcon } from 'src/components/ui-icons/upload';
import { FlexCol, FlexRow } from 'src/utils/flexLayouts';
import { selectModelData } from '../selectors/selectors';
import { fetchData } from '../actions/actions';
import { BACKEND_URL } from '../api/config';
import { s3cloudUrl, siteUrl, strapiAdminUrl } from "src/api/config";
import axios from "axios";
import Loading from "src/components/Loading";
import EyeIcon from "src/components/ui-icons/reports/EyeIcon";
import { Modal } from "src/components/DialogComponent";
import ImagesList from "src/components/ImagesList";
import TGButton from "src/components/ui/TGButton";

export default function HelpGop() {
  const dispatch = useAppDispatch();
  const contacts = useAppSelector((state: any) => selectModelData(state, 'gop-contacts'));
  const instructions = useAppSelector((state: any) => selectModelData(state, 'gop-instructions'));
  const [viewDocMode, setViewDocMode] = useState(false);
  const [imagesDoc, setImagesDoc] = useState<any>([]);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previeFileId, setPreviewFileId] = useState<any>(null);

  useEffect(() => {
    dispatch(fetchData('gop-contacts'));
    dispatch(fetchData('gop-instructions'));
  }, [dispatch]);

  useEffect(() => {
    if (imagesDoc.length > 0) {
      setViewDocMode(true);
    }
  }, [imagesDoc]);

  const isCloudLink = (str: string) => {
    return str.includes(s3cloudUrl);
  }

  const downLoadHandle = (e: any, url: string, name: string, fileId: number) => {
    e.preventDefault();
    e.stopPropagation();
    setPreviewFileId(fileId);
    if (!e.target.id && (url.indexOf('.jpg') !== -1 || url.indexOf('.jpeg') !== -1 || url.indexOf('.gif') !== -1 || url.indexOf('.png') !== -1)) {
      setImagesDoc([url]);
      setPreviewFileId(null);
    } else if (!e.target.id && (url.indexOf('.docx') !== -1 || url.indexOf('.xlsx') !== -1)) {
      setPreviewLoading(true);
      const fullUrl = isCloudLink(url)
        ? `${BACKEND_URL}/${new URL(url).pathname.slice(1)}`
        : `${BACKEND_URL}${url}`;
      axios.post(`${siteUrl}/api/md-documents-files/preview_path`, {
        id: fileId,
        path: fullUrl.replace(siteUrl, strapiAdminUrl),
      }, { withCredentials: true }).then(results => {
        const { data } = results;
        setImagesDoc(data.map((url: string) => `${siteUrl}${url}`));
        setPreviewLoading(false);
        setPreviewFileId(null);
      });
    } else {
      const fullUrl = isCloudLink(url)
        ? `${BACKEND_URL}/${new URL(url).pathname.slice(1)}`
        : `${BACKEND_URL}${url}`;
      const link = document.createElement('a');
      link.href = fullUrl;
      link.download = name;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setPreviewFileId(null);
    }
  };


  return (
    <div>
      <div className='px-7.5 py-[26px] border-b border-[#DFE4EA]-500'>
        <div className='flex items-center gap-2 hover:cursor-pointer w-fit'>
          <span>
            <HelpIcon />
          </span>
          <span>Помощь</span>
        </div>
      </div>
      <div className='p-7.5'>
        <div className='flex gap-5 mb-5'>
          {contacts.map((contact: any) => (
            <div key={contact.id || contact.ID} className='p-7.5 border rounded-lg bg-white shadow-md w-full gap-5 flex flex-col'>
              <h4 className='text-black text-[18px] font-medium leading-6'>{contact.Title}</h4>
              {contact.Phone && (
                <div>
                  <span>Телефон: </span>
                  <a className='text-darkblue' href={`tel:${contact.Phone}`}>
                    {contact.Phone}
                  </a>
                </div>
              )}
              {contact.Email && (
                <div>
                  <span>Email: </span>
                  <a className='text-darkblue' href={`mailto:${contact.Email}`}>
                    {contact.Email}
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className='p-7.5 border rounded-lg bg-white shadow-md w-full'>
          <h4 className='text-black text-[18px] font-medium leading-6 mb-5'>Инструкции</h4>
          <FlexCol className='gap-5'>
            <div className='flex flex-row'>
              <div className='flex flex-col gap-y-5 w-full'>
                {instructions.map((instruction: any) =>
                  instruction.Doc.map((file: any) => (
                    <div
                      key={file.id}
                      onClick={(e) => downLoadHandle(e, file.url, file.name, file.id)}
                      className='flex flex-row justify-between gap-3 px-4 py-2 rounded-lg cursor-pointer upload bg-sp-gray'
                    >
                      <div className='flex flex-row gap-x-3 items-center flex-grow'>
                        <div className='flex flex-col items-center justify-center text-gray-400'>
                          <FileIcon />
                        </div>
                        <div className='flex flex-col'>
                          <span>{file.name}</span>
                        </div>
                      </div>
                      <FlexRow className="justify-center items-center gap-5">
                        {file.id && (file.url.indexOf('.jpg') !== -1 || file.url.indexOf('.jpeg') !== -1 || file.url.indexOf('.gif') !== -1 || file.url.indexOf('.png') !== -1 || file.url.indexOf('.docx') !== -1 || file.url.indexOf('.xlsx') !== -1) &&
                          <>
                            {previewLoading && previeFileId === file.id &&
                              <FlexCol className="flex w-6 h-6">
                                <Loading />
                              </FlexCol> ||
                              <EyeIcon />
                            }
                          </>
                        }
                        <div className='flex flex-col items-center justify-center text-gray-400 hover:text-blue-500 transition-colors'>
                          <DownloadIcon />
                        </div>
                      </FlexRow>
                    </div>
                  ))
                )}
              </div>
            </div>
          </FlexCol>
        </div>
      </div>
      <Modal
        zIndex={70}
        modalClassName="min-h-px flex gap-5 p-10"
        open={viewDocMode}
        toggleDialog={setViewDocMode}
      >
        <ImagesList
          images={imagesDoc}
        />
        <FlexRow className="w-full justify-center items-center">
          <TGButton onClick={() => {
            setImagesDoc([]);
            setViewDocMode(false);
          }} color="bluedark">
            Закрыть
          </TGButton>
        </FlexRow>
      </Modal>
    </div>
  );
}